import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row } from "react-bootstrap";

//components
import applicationRouter from "../../../hoc/applicationRouter";
import withLocalization from "../../../hoc/withLocalization";

import HolidayRecommendationModal from "../../../components/HolidaySettings/HolidayRecommendationModal";

class ModuleSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        const { t } = this.props;
        return(
            <div>
                <Row>
                    <h6>{t('Holiday Settings')}</h6>
                    <HolidayRecommendationModal />
                </Row>
            </div>
        )
    }
}

export default inject('clientStore', 'commonStore')(applicationRouter(withLocalization(observer(ModuleSettings))));
